import React from 'react';
import {inject, observer} from 'mobx-react';
import {Row, Col, Form, Input, Button, Checkbox, message} from 'antd';

const createForm = Form.create;
const FormItem = Form.Item;

@inject('initStore')
@observer
class LoginContent extends React.Component {

  componentDidMount() {
    const rememberId = localStorage.rememberId === 'true';
    const rememberPass = localStorage.rememberPass === 'true';
    const loginId = localStorage.loginId || '';
    const loginPass = localStorage.loginPass || '';
    const { initStore } = this.props;
    if (loginId && loginId !== '') {
      initStore.generateCaptcha({ mobile: loginId });
    }
    initStore.setState({ rememberId, rememberPass, loginId, loginPass });
    window.addEventListener('keydown', this.login);
  }
  componentWillUnmount() {
    window.removeEventListener('keydown', this.login);
  }
  login = (e) => {
    if (e.keyCode === 13) {
      this.handleSubmit();
    }
  }
  handleSubmit() {
    const { initStore, isEclogin, isModal } = this.props;
    const { doLogin, doEcLogin, loginId, loginPass, captcha } = initStore;
    if (loginId === '' || loginPass === '') {
      message.config({
        top: 20,
      });
      message.error('请输入用户名、密码');
    } else if (captcha === '') {
      message.error('请输入验证码');
    } else {
      const values = {
        usertype: loginId.trim() === 'admin' ? 1 :0,
        username: loginId.trim(),
        password: loginPass.trim(),
        captcha,
      };
      isEclogin ? doEcLogin(values) : doLogin(values, isModal);
    }
  }

  render() {
    const {
      isEclogin,
      isModal,
      initStore: {
        ecloginStatus, setState, me, ecloginKey, rememberId, rememberPass,
        loginId, loginPass, loading, captchaImg, captcha, generateCaptcha
      },
    } = this.props;
    const formItemLayout = {
      labelCol: { span: 1 },
      wrapperCol: { span: 16 },
    };
    return (
      <Col className='login-wrapper'>
        {
          !isModal ? [
            <div key="logo" className='icon-Cloud-Logo'/>,
            <div key="title" className='login-wrapper-title'>云商店</div>
          ] : null
        }
        <div className='login-wrapper-con'>
          <div className='login-wrapper-con-bg' style={isEclogin ? { height: 300 }: null}>
            <div className='login-wel'>
              {`欢迎${isEclogin && ecloginStatus === 2
                ? '您! ' + (me.data ? me.data.member.m_name : '')
                : '登录'}`}
            </div>
          </div>
          {
            !isEclogin ? null
            : ecloginStatus === 0 ?
            <div style={{ marginTop: 60 }}>
              <Button
                type="primary"
                className='login-btn'
                onClick={() => window.open()}
              >使用当前ecology账号登录</Button>
              <Button
                type="primary"
                className='login-btn'
                onClick={() => setState({ ecloginStatus: 1 })}
              >使用账号密码登录</Button>
            </div>
            : ecloginStatus === 2
            ? <div style={{ marginTop: 60 }}>
              <Button
                type="primary"
                className='login-btn'
                onClick={() => window.open(`https://e-cloudstore.com/#/?eclogin=1&ecloginkey=${ecloginKey}`)}
              >打开云商店</Button>
              <Button
                type="primary"
                className='login-btn'
                onClick={() => setState({ ecloginStatus: 1, me: {}, ecloginkey: '' })}
              >切换账号</Button>
            </div>
            : null
          }
          <Form style={{"marginTop": "60px", display: !isEclogin ? 'block' : ecloginStatus === 1 ? 'block' : 'none' }}>
            <Row>
              <Col>
                <FormItem {...formItemLayout} label="">
                  <Input value={loginId} placeholder="请输入用户名"
                    onChange={e => setState({ loginId: e.target.value, captcha: '' })}
                    onBlur={() => {
                      generateCaptcha({ mobile: loginId });
                    }} />
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col>
                <FormItem {...formItemLayout} label="">
                  <Input value={loginPass} type="password" placeholder="请输入密码"
                    onChange={e => setState({ loginPass: e.target.value })} />
                </FormItem>
              </Col>
            </Row>
            {
              loginId && loginId.trim() !== '' && captchaImg !== '' && (
                <Row>
                  <Col>
                    <FormItem {...formItemLayout} label="">
                      <div className="login-captcha">
                        <Input value={captcha} placeholder="请输入验证码"
                          onChange={e => setState({ captcha: e.target.value })} />
                        <img src={'data:image/png;base64,' + captchaImg} className="login-captcha-img" onClick={() => {
                          generateCaptcha({ mobile: loginId });
                        }}/>
                      </div>
                    </FormItem>
                  </Col>
                </Row>
              )
            }
            <Row>
              <Col>
                <FormItem  {...formItemLayout} label="">
                  <Button type="primary" className='login-btn' loading={loading}
                          onClick={this.handleSubmit.bind(this)}>登录</Button>
                </FormItem>
              </Col>
            </Row>
            <Row style={{ display: isEclogin ? 'none' : 'block' }}>
              <Col span={12}>
                <FormItem  {...formItemLayout} label="">
                  <Checkbox checked={rememberId} onChange={e => {
                    setState({ rememberId: e.target.checked });
                    if (!e.target.checked) setState({ rememberPass: false });
                  }}><span className='login-password-tip'>记住用户名</span></Checkbox>
                </FormItem>
              </Col>
              <Col span={12} className='login-psd'>
                <FormItem  {...formItemLayout} label="">
                  <Checkbox checked={rememberPass} onChange={e => setState({ rememberPass: e.target.checked, rememberId: true })}><span className='login-password-tip'>记住密码</span></Checkbox>
                </FormItem>
              </Col>
              {/* <Col span={12}>
                <div className='login-password-tip login-password-tip2'>
                  <span>忘记密码？</span>
                  <span>/</span>
                  <span onClick={() => {
                    routing.push({
                      pathname: '/register',
                    })
                  }}>立即注册</span>
                </div>
              </Col> */}
            </Row>
            {
              // this.props.page.error ?
              //   <Row>
              //     <Col>
              //       <FormItem  label="">
              //         <div><font color="#FF0000">用户名或密码错误</font></div>
              //       </FormItem>
              //     </Col>
              //   </Row> : ""
            }
          </Form>
        </div>
      </Col>
    )
  }
}

LoginContent = createForm()(LoginContent);
export default LoginContent;


// WEBPACK FOOTER //
// ./src/components/init/LoginContent.js